<button
  id="verbal-prompt-button"
  class="verbal-prompt-button"
  type="button"
  (click)="onClick()"
  [attr.data-testid]="testId"
  htcAudioClick
  [audioType]="clickType"
  [descriptor]="clickDescriptor">
  <div class="button-circle-thumb">
    <div class="button-circle-thumb-shadow"></div>
    <div class="button-circle-thumb-circle"></div>
    <img class="button-circle-thumb-icon" [src]="path + icon" />
  </div>
</button>
